
import React, { useRef, useState, useEffect } from 'react'
import {
usePopupState,
        bindHover,
        bindPopover,
        } from 'material-ui-popup-state/hooks'
import './User.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import Popover from 'material-ui-popup-state/HoverPopover'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { useHistory } from 'react-router-dom'
import FetchData from '../../../shared/fetchData'
import Modal from '../../UI/Modal/Modal'

        const User = (props) => {

    const [token, setToken] = useState(window.localStorage.getItem("token"))
    const [balance, setBalance] = useState()
    const [content, setContent] = useState()
    const [loading, setLoading] = useState(false)
    const childRef = useRef();

    let history = useHistory();

    const getMyOrders = (event) => {
        history.push('/my-orders');
    }

    const doLogout = (event) => {
        window.localStorage.setItem("token", "")
        setToken("")
        props.setToken()
        history.push('/')
    }
    const closeModal = (event) => {
        childRef.current.closeModal()
    }

    const afterCloseModal = (event) => {
    }

    const popupState = usePopupState({
        variant: 'popover',
        popupId: 'demoPopover',
    })

    let sideMenu = ''
    if (token !== '' && token !== null) {
        sideMenu =
                <div>
                
                    <Button className="UserMenu" variant="contained" {...bindHover(popupState)}>
                        <FontAwesomeIcon className="UserIcon" icon={faUser} />
                    </Button>
                    <Popover
                        {...bindPopover(popupState)}
                        anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                        transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        disableRestoreFocus
                        >
                        <Typography style={{margin: 10, fontFamily: 'iranyekan', overflow: 'hidden'}}>
                            <div className="row justify-content-center">
                                <div className="col">
                                    <div className="row" onClick={getMyOrders}>
                                        <div className="UserContent">
                                            بیمه نامه های من
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center" style={{borderTop: '1px solid gray'}}>
                            </div>
                            <div className="row justify-content-center mt-4">
                
                                <div className="col-11">
                
                                    <div className="LastComponent" onClick={doLogout}>
                                        <div className="FooterText">
                                            خروج
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Typography>
                    </Popover>
                </div>
    }

    const setTokenValue = () => {
        const tokenValue = window.localStorage.getItem("token")
        setToken(tokenValue)
        bindHover(popupState)
    }

    return (
            <div>
                {sideMenu}
                < Modal
                content={content}
                ref={childRef}
                closePermission={true}
                closeModal={(event) => afterCloseModal(event)}
                />
            </div>
            )
}
export default User